import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';

// Pages
import UserProfile from './pages/UserProfile/UserProfile';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import SignIn from './pages/SignIn/SignIn';
import Testimonials from './pages/Testimonials/Testimonials';
import Admin from './pages/Admin/Admin';
import Articles from './pages/Articles/Articles';
import Abonamente from "./pages/Abonamente/Abonamente_stripe";
import TrainAndTravel from "./pages/TrainAndTravel/TrainAndTravel"; // 1. Ensure this import exists

function App() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);

    return (
        <div className="App">
            <Router>
                <NavBar user={user} />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/signin" element={<SignIn />} />
                    <Route path="/profile" element={<UserProfile />} />
                    <Route path="/admin" element={<Admin user={user} />} />
                    <Route path="/articles" element={<Articles />} />
                    <Route path="/testimonials" element={<Testimonials user={user} />} />
                    <Route path="/plans" element={<Abonamente user={user} />} />

                    {/* 👇 THIS WAS THE ISSUE 👇 */}
                    {/* The path must be "/train-travel" because that is what your NavBar is linking to */}
                    <Route path="/train-travel" element={<TrainAndTravel />} />

                </Routes>
                <Footer />
            </Router>
        </div>
    );
}

export default App;